import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/requestall/mocker'

export default {
  getColumnsLabels () {
    if (isMock) return generator(mocker.columnsLabels())
    return instance().get(endpoint + '/requestall/columnsLabels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/requestall/index', { params: searchParams })
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/requestall/dropdowns')
  }
}



// WEBPACK FOOTER //
// ./src/api/requestall/index.js